import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MovieProposal from "./movieProposal";
import Movies from "./movies";
import FaqTree from "./faqTree";
import Newsletter from "./newsletter";
import { message } from "antd";
import { useAuth } from "../contexts/AuthContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const Home: React.FC = () => {
  const { user } = useAuth();
  const [description, setDescription] = useState<string>("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      if (params.has("merci")) {
        message.success("Merci pour votre contribution !");
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    const docRef = doc(db, "settings", "public");
    const unsubscribe = onSnapshot(docRef, (snapshot) => {
      const data = snapshot?.data();
      setDescription(data?.description || "");
    });

    return () => unsubscribe();
  }, [user]);

  return (
    <div className="min-h-screen flex flex-col gap-6">
      <div className="flex flex-col gap-6 p-3 md:p-6 flex-grow">
        <div className="flex flex-col">
          <h1>Cinemir.</h1>
          <b>Un ciné-club participatif à Sion.</b>
          {description && <p className="whitespace-pre-line">{description}</p>}
          <Link to="/history" className="text-xs underline mt-1">Historique des films</Link>
        </div>
        <div className="flex gap-2 flex-row">
          <MovieProposal />
          <Newsletter />
        </div>
        <Movies />
        <FaqTree />
      </div>
      <div className="w-full p-3 md:p-6 flex flex-col md:flex-row md:items-center gap-1 md:gap-0">
        <a href="mailto:contact@cinemir.ch">contact@cinemir.ch</a>
        <span className="hidden md:block mx-1">/</span>
        <span>Association Cinemir, Avenue de Tourbillon 36b, 1950 Sion</span>
        <span className="hidden md:block mx-1">/</span>
        <Link to="/legal" className="text-xs underline">Mentions légales</Link>
      </div>
    </div>
  );
};

export default Home;
